export default {
  defaultTheme: 'phoenix',
  variations: {
    colors: [
      'primary',
      'secondary',
      'error',
      'success',
      'warning',
    ],
    lighten: 4,
    darken: 4,
  },
  themes: {
    material: {
      colors: {
        'background': '#FFFFFF',
        'background-variant': '#1867C0',
        'surface': '#FFFFFF',
        'surface-bright': '#FFFFFF',
        'surface-light': '#EEEEEE',
        'surface-variant': '#424242',
        'on-surface-variant': '#EEEEEE',
        'primary': '#1867C0',
        'primary-darken-1': '#1F5592',
        'secondary': '#48A9A6',
        'secondary-darken-1': '#018786',
        'error': '#B00020',
        'info': '#2196F3',
        'success': '#4CAF50',
        'warning': '#FB8C00',
      },
    },
    materialDark: {
      dark: true,
      colors: {
        'background': '#121212',
        'background-variant': '#2196F3',
        'surface': '#212121',
        'surface-bright': '#ccbfd6',
        'surface-light': '#424242',
        'surface-variant': '#c8c8c8',
        'on-surface-variant': '#000000',
        'primary': '#2196F3',
        'primary-darken-1': '#277CC1',
        'secondary': '#54B6B2',
        'secondary-darken-1': '#48A9A6',
        'error': '#CF6679',
        'info': '#2196F3',
        'success': '#4CAF50',
        'warning': '#FB8C00',
      },
    },
    phoenix: {
      colors: {
        'primary': '#904640',
        'on-primary': '#FFFFFF',
        'primary-container': '#FFCFCB',
        'on-primary-container': '#3A0B08',

        'secondary': '#775651',
        'on-secondary': '#FFFFFF',
        'secondary-container': '#FFDAD3',
        'on-secondary-container': '#2C1511',

        'tertiary': '#6F5B2E',
        'on-tertiary': '#FFFFFF',
        'tertiary-container': '#FADFA6',
        'on-tertiary-container': '#271900',

        'error': '#BA1A1A',
        'on-error': '#FFFFFF',
        'error-container': '#FFDAD6',
        'on-error-container': '#410002',

        'background': '#FFF8F6',
        'background-variant': '#FFCFCB', // used for coloring site background image
        'on-background': '#201A19',

        'surface': '#FFF8F6',
        'on-surface': '#201A19',

        'surface-variant': '#FFCFCB',
        'on-surface-variant': '#534341',

        'outline': '#857370',
        'shadow': '#000000',
        'inverse-surface': '#362F2E',
        'inverse-on-surface': '#FBEDEA',
      },
    },
    phoenixDark: {
      dark: true,
      colors: {
        'surface-variant-alt': '#333333',
        'accent': '#FF4081',
        'surface-bright': '#474747',

        'primary': '#BA6B65',
        'primary-container': '#732F29',
        'on-primary-container': '#FFCFCB',

        'secondary': '#E7BDB5',
        'on-secondary': '#442926',
        'secondary-container': '#5D3F3B',
        'on-secondary-container': '#FFDAD3',

        'tertiary': '#DDC38C',
        'on-tertiary': '#3E2E04',
        'tertiary-container': '#574419',
        'on-tertiary-container': '#FADFA6',

        'error': '#FFB4AB',

        'background': '#1B1211',
        'background-variant': '#BA6B65',
        'on-background': '#ECDFDD',

        'surface': '#1B1211',
        'on-surface': '#ECDFDD',

        'surface-variant': '#534341',
        'on-surface-variant': '#D8C2BE',

        'outline': '#9F8C89',
        'shadow': '#000000',
        'inverse-surface': '#ECDFDD',
        'inverse-on-surface': '#2F2322',
      },
    },
    phoenixOld: {
      colors: {
        'background': '#FFFFFF',
        'background-variant': '#DDD8F3',
        'surface': '#FFFFFF',
        'surface-bright': '#FFFFFF',
        'surface-light': '#EEEEEE',
        'surface-variant': '#424242',
        'on-surface-variant': '#EEEEEE',
        'primary': '#673AB7',
        'primary-darken-1': '#1F5592',
        'secondary': '#48A9A6',
        'secondary-darken-1': '#018786',
        'error': '#B00020',
        'info': '#2196F3',
        'success': '#4CAF50',
        'warning': '#FB8C00',
      },
    },
    phoenixOldDark: {
      dark: true,
      colors: {
        'background': '#121212',
        'background-variant': '#9d7dd6',
        'surface': '#212121',
        'surface-bright': '#ccbfd6',
        'surface-light': '#424242',
        'surface-variant': '#c8c8c8',
        'on-surface-variant': '#000000',
        'primary': '#9d7dd6',
        'primary-darken-1': '#277CC1',
        'secondary': '#54B6B2',
        'secondary-darken-1': '#48A9A6',
        'error': '#CF6679',
        'info': '#2196F3',
        'success': '#4CAF50',
        'warning': '#FB8C00',
      },
    },
  },
}
